import { render, staticRenderFns } from "./InstructionDetail.vue?vue&type=template&id=0bf22069"
import script from "./InstructionDetail.vue?vue&type=script&lang=js"
export * from "./InstructionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports